import React, { useState } from 'react'
import { Route, Routes } from "react-router-dom";
import Sidebar from '../components/Sidebar/Sidebar';
import Buildings from '../pages/authenticatedPages/Buildings/Buildings';
import Dashboard from '../pages/authenticatedPages/Dashboard/Dashboard';
import Investors from '../pages/authenticatedPages/Investors/Investors';
import Projects from '../pages/authenticatedPages/Projects/Projects';
import { useSelector } from "react-redux"
import ErrorPage from '../pages/authenticatedPages/Error/ErrorPage';
import SignIn from '../pages/nonAuthenticatedPages/SignIn/SignIn';
import Gala from '../pages/authenticatedPages/Galas/Gala';
import BuildingViewCard from '../components/BuildingViewCard/BuildingViewCard';
import ProjectViewCard from '../components/ProjectViewCard/ProjectViewCard';
import SoldGalas from '../pages/authenticatedPages/SoldGalas/SoldGalas';
import TenantGala from '../pages/authenticatedPages/TenantGalas/TenantGala/TenantGala';
import Villages from '../pages/authenticatedPages/Masters/Villages/Villages';
import Constitution from '../pages/authenticatedPages/Masters/Constitution/Constitution';
import Units_Measure from '../pages/authenticatedPages/Masters/Units_Measure/Units_Measure';
import InvestorViewCard from '../components/InvestorViewCard/InvestorViewCard';
import InvestorType from '../pages/authenticatedPages/Masters/InvestorType/InvestorType';
import PermissionType from '../pages/authenticatedPages/Masters/PermissionType/PermissionType';
import WaterSupply from '../pages/authenticatedPages/Masters/WaterSupply/WaterSupply';
import ElectricityConnection from '../pages/authenticatedPages/Masters/ElectricityConnection/ElectricityConnection';
import City from '../pages/authenticatedPages/Masters/City/City';
import Proposal from '../pages/authenticatedPages/Customers/ Proposal/ Proposal';
import DraftedProposal from '../pages/authenticatedPages/Customers/ Proposal/DraftedProposal';
import DocumentsName from '../pages/authenticatedPages/Masters/DocName/DocumentsName';
import TenantGalasView from '../pages/authenticatedPages/TenantGalas/TenantGala/TenantGalasView';
import BuildingType from '../pages/authenticatedPages/Masters/BuildingType/BuildingType';
import SearchInvestors from '../pages/authenticatedPages/Dashboard/SearchInvestors/SearchInvestors';
import FloorType from '../pages/authenticatedPages/Masters/FloorType/FloorType';
import Lot_intent from '../pages/authenticatedPages/Masters/Lot_Intent/Lot_intent';
import OnBasis from './../pages/authenticatedPages/Masters/OnBasis/OnBasis';
import Settings from '../pages/authenticatedPages/Settings/Settings';
import SoldGalaViewCard from './../components/SellGalaViewCard/SoldGalaViewCard';
import Billing from '../pages/authenticatedPages/Maintainence/Billing/Billing';
import Generatedbills from '../pages/authenticatedPages/Maintainence/Billing/Generatedbills';
import Poc from '../pages/authenticatedPages/Masters/POC/Poc';
import GST from './../pages/authenticatedPages/Masters/GST/GST';
import HSN from './../pages/authenticatedPages/Masters/HSN_SOC/HSN';
import PrintPreview from '../pages/authenticatedPages/Maintainence/Billing/PrintPreview';
import TenantAgeing from '../pages/authenticatedPages/TenantGalas/TenantAgeing/TenantAgeing';
import SoldHistory from '../pages/authenticatedPages/SoldGalas/SoldHistory';
import TenantHistory from '../pages/authenticatedPages/TenantGalas/TenantHistory/TenantHistory';
import CustomBill from '../pages/authenticatedPages/Maintainence/customBill/customBill';
import CustomPreview from '../pages/authenticatedPages/Maintainence/Billing/CustomPreview';
import Querys from '../pages/authenticatedPages/Querys/Querys';
import QueryViewCard from '../components/QueryViewCard/QueryViewCard';
import ResellReason from '../pages/authenticatedPages/Masters/ResellReason/ResellReason';
import Registration from '../pages/authenticatedPages/Registration/Registration';
import GeneratedBillInvoice from '../components/Modal/PDF/Invoice/GeneratedBillInvoice';
import BillSendFrom from '../pages/authenticatedPages/Masters/BillSendFrom/BillSendFrom';

const ProjectRoutes = () => {
  const Logged = useSelector((state) => state?.Reducers?.loggedIn);
  const [lodingSpinner, setLodingSpinner] = useState()
  const spinner = document.getElementById('lodingSpinner')

  if (spinner) {
    setTimeout(() => {
      spinner.style.display = 'none';
      setLodingSpinner(true)
    }, 2000);
  }

  return (
    lodingSpinner && (
      <>
        {Logged ?
          <Sidebar>
            <Routes>
              <Route path="/" element={<SearchInvestors />} />
              <Route path="/InvestorChart" element={<Dashboard />} />
              <Route path="/Proposal" element={<Proposal />} />
              <Route path="/DraftedProposal" element={<DraftedProposal />} />
              <Route path="/Projects" element={<Projects />} />
              <Route path="/Buildings" element={<Buildings />} />
              <Route path="/Investors" element={<Investors />} />
              <Route path="/Villages" element={<Villages />} />
              <Route path="/Lot_intent" element={<Lot_intent />} />
              <Route path="/Poc" element={<Poc />} />
              <Route path="/DocumentsName" element={<DocumentsName />} />
              <Route path="/Constitution" element={<Constitution />} />
              <Route path="/InvestorType" element={<InvestorType />} />
              <Route path="/FloorType" element={<FloorType />} />
              <Route path="/BuildingType" element={<BuildingType />} />
              <Route path="/PermissionType" element={<PermissionType />} />
              <Route path="/WaterSupply" element={<WaterSupply />} />
              <Route path="/BillSendFrom" element={<BillSendFrom />} />
              <Route path="/ElectricityConnection" element={<ElectricityConnection />} />
              <Route path="/Units_Measure" element={<Units_Measure />} />
              <Route path="/City" element={<City />} />
              <Route path="/Buildings/:id" element={<BuildingViewCard />} />
              <Route path="/Projects/:id" element={<ProjectViewCard />} />
              <Route path="/Investors/:id" element={<InvestorViewCard />} />
              <Route path="/Gala" element={<Gala />} />
              <Route path="/SoldGalas" element={<SoldGalas />} />
              <Route path="/SoldHistory" element={<SoldHistory />} />
              <Route path="/SoldGalas/:id" element={<SoldGalaViewCard />} />
              <Route path="/TenantGala" element={<TenantGala />} />
              <Route path="/TenantGala/:id" element={<TenantGalasView />} />
              <Route path="/TenantAgeing" element={<TenantAgeing />} />
              <Route path="/TenantHistory" element={<TenantHistory />} />
              <Route path="/Billing" element={<Billing />} />
              <Route path="/Generatedbills" element={<Generatedbills />} />
              <Route path="/CustomBill" element={<CustomBill />} />
              <Route path="/PrintPreview" element={<PrintPreview />} />
              <Route path="/CustomBill/:id" element={<CustomPreview />} />
              <Route path="/BillInvoice/" element={<GeneratedBillInvoice />} />
              <Route path="/OnBasis" element={<OnBasis />} />
              <Route path="/Gst" element={<GST />} />
              <Route path="/HSN" element={<HSN />} />
              <Route path="/Settings" element={<Settings />} />
              <Route path="/ResellReason" element={<ResellReason />} />
              <Route path="/Querys" element={<Querys />} />
              <Route path="/Query/:id" element={<QueryViewCard />} />
              <Route path="/Registration" element={<Registration />} />
              <Route path="*" element={<ErrorPage />} />
            </Routes>
          </Sidebar>
          :
          <Routes>
            <Route path="/" element={<SignIn />} />
          </Routes>
        }
      </>
    )
  )
}

export default ProjectRoutes